import {useNavigate, useLocation} from 'react-router-dom'

const ignorePaths = ['/', '/login', '/signup', '/forgot-password']

export function useGotoLogin() {
  const navigate = useNavigate()
  const location = useLocation()

  return () => {
    let from = location?.pathname + location?.search || '/'
    if (ignorePaths.includes(location?.pathname)) {
      from = '/'
    } 
    sessionStorage.setItem('_aog_login_redirect_url', from)
    navigate('/login', {replace: true, state: {from}})
  }
}
